import {
  SIGNED_WAIVER_SUCCEEDED,
  SIGNED_WAIVER_FAILED,
  SIGNED_WAIVER_SUBMIT_STARTED,
  VALUES_SUBMITTED,
  LOCATION_RETRIEVED,
  PATH_REFERENCE_RETRIEVED,
  PATH_PARTICIPANTS_RETRIEVED,
  UPDATE_PPS,
  LINKED_PARTICIPANTS,
  LINKED_PARTICIPANTS_SIGNEDBY,
  PPS_SELECTED,
  PARTICIPANT_REMOVED,
  SELECTED_NAMES,
  LINKED_PARTICIPANT
} from "../constants";
import fetch from "isomorphic-fetch";
import omitEmpty from "omit-empty";
import {
  find,
  head,
  init,
  isEmpty,
  has,
  length,
  pluck,
  propEq,
  reject,
  drop
} from "ramda";

const submitValues = values => (dispatch, getState) => {
  const signedWaiverData = {
    waiverId: getState().currentWaiver.waiverId,
    signVideoSessionId: getState().recording.id,
    signedByRole: getState().signingInfo.role,
    optIn: getState().signingInfo.optIn,
    contactEmail: getState().signingInfo.email,
    contactPhone: getState().signingInfo.phoneNumber,
    emergencyPhone: getState().signingInfo.icePhoneNumber,
    participants: getState().signingInfo.participants,
    signedByName: getState().signingInfo.name,
    signerInitials: getState().signingInfo.signerInitials,
    lat: getState().locationData.lat,
    lon: getState().locationData.lon,
    referenceKey: getState().pathInfo.refLocation,
    signature: getState().signingInfo.signature,
    kioskWaiverKey: getState().signedWaiver.guid
  };
  const signedWaiver = omitEmpty(signedWaiverData);
  dispatch({ type: VALUES_SUBMITTED, payload: signedWaiver });
};

export const submitSignedWaiver = () => async (dispatch, getState) => {
  dispatch(submitValues());
  dispatch({
    type: SIGNED_WAIVER_SUBMIT_STARTED,
    payload: {
      submitting: true
    }
  });
  const result = await fetch(`${process.env.PUBLIC_URL}/api/Sign/Post`, {
    headers: {
      "Content-Type": "application/json"
    },
    method: "POST",
    body: JSON.stringify(getState().signedWaiver.data)
  })
    .then(res => res.json())
    .catch(err => dispatch({ type: SIGNED_WAIVER_FAILED }));
  if (result.status === 0 || result.Status === 0) {
    dispatch({ type: SIGNED_WAIVER_SUCCEEDED });
  } else {
    dispatch({ type: SIGNED_WAIVER_FAILED });
  }
};

export const getCoords = () => (dispatch, getState) => {
  if (navigator.geolocation) {
    //check if geolocation is available
    navigator.geolocation.getCurrentPosition(
      function (position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        dispatch({
          type: LOCATION_RETRIEVED,
          payload: { lat: latitude, lon: longitude }
        });
      },
      err => console.log("geo err", err),
      { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
    );
  }
};



export const getPathParticipants = () => (dispatch, getState) => {
  var pathArray = window.location.pathname.split("/");
  var paLength = length(pathArray);
  var remainingPath = pathArray[Number(paLength) - 1];
  const decodedArray = decodeURI(remainingPath);

  const participantsArray = decodedArray.split(";");
  const initParticipantsArray = init(participantsArray);
  const partArray = initParticipantsArray.map(p => {
    const splitArray = p.split("^");
    return splitArray[0].length === 0
      ? ""
      : {
        participantName: splitArray[0],
        referenceKey: splitArray[1],
        participantId: Math.floor(Math.random() * 1000)
      };
  });
  var linkedPath = !isEmpty(partArray) ? true : false;
  dispatch({
    type: PATH_PARTICIPANTS_RETRIEVED,
    payload: { participants: partArray, linkedPath: linkedPath }
  });
};

export const getLinkedParticipants = id => (dispatch, getState) => {
  const role = getState().signingInfo.role;

  const pps = getState().pathParticipants.participants;

  const signedBy = head(pps);

  const person = find(propEq("participantId", Number(id)))(pps);

  const updatedPps = reject(p => p.participantId === Number(id), pps);

  if (role === 2 || !isEmpty(getState().pathParticipants.linkedParticipants)) {
    dispatch({
      type: LINKED_PARTICIPANTS,
      payload: id
    });
    dispatch({
      type: PPS_SELECTED,
      payload: [person]
    });
    dispatch({
      type: SELECTED_NAMES,
      payload: person
    });
    dispatch({
      type: UPDATE_PPS,
      payload: updatedPps
    });
  } else if (role === 1) {
    dispatch({ type: LINKED_PARTICIPANT, payload: id });
  } else {
    dispatch({ type: LINKED_PARTICIPANT, payload: id });
    dispatch({
      type: LINKED_PARTICIPANTS_SIGNEDBY,
      payload: signedBy.participantName
    });
    dispatch({
      type: LINKED_PARTICIPANTS,
      payload: id
    });
    dispatch({
      type: PPS_SELECTED,
      payload: [person]
    });
    dispatch({
      type: SELECTED_NAMES,
      payload: person
    });
    dispatch({
      type: UPDATE_PPS,
      payload: updatedPps
    });
  }
};

export const removeParticipant = id => (dispatch, getState) => {
  const linkedParticipants = getState().pathParticipants.linkedParticipants;

  const selectedParticipants = reject(
    propEq("participantName", `${id}`),
    linkedParticipants
  );

  const selectedNames = pluck(`participantName`, selectedParticipants);

  dispatch({
    type: PARTICIPANT_REMOVED,
    payload: {
      selectedParticipants: selectedParticipants,
      selectedNames: selectedNames
    }
  });
};
